import { useStoreSelector } from '@/store/core';
import type { RootState } from '@/store';

/**
 * Typed selector hook
 * Uses the abstraction layer internally
 */
export const useAppSelector = <Selected = unknown>(
  selector: (state: RootState) => Selected,
  equalityFn?: (left: Selected, right: Selected) => boolean,
): Selected => {
  return useStoreSelector<RootState, Selected>(selector, equalityFn);
};
